import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { LifetimePartnerForm } from '../components/Payment/LifetimePartnerForm';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, ArrowRight, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
export const LifetimePartner = () => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success' | 'form'>('pending');
  const [reference, setReference] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('https://formspree.io/f/mldpapna', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        setPaymentStatus('success');
        // Redirect to WhatsApp group
        window.location.href = 'https://chat.whatsapp.com/BslF3e6Z9hk4ar8agDfQ51';
      } else {
        throw new Error('Form submission failed');
      }
    }).catch(error => {
      console.error('Error:', error);
      // Handle error state
    });
  };
  if (paymentStatus === 'success') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3529">
        <div className="container mx-auto px-4 py-16" data-id="element-3530">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3531">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3532">
              <Check size={40} className="text-gray-700" data-id="element-3533" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3534">
              Welcome to The Networking Salon Lifetime Partner Access!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3535">
              Thank you for joining our community. Your registration was
              successful.
            </p>
            <p className="text-gray-600 mb-12" data-id="element-3536">
              We're redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3537">
        <div className="container mx-auto px-4 py-16" data-id="element-3538">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3539">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3540">
              <Check size={40} className="text-gray-700" data-id="element-3541" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3542">
              Payment Successful!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3543">
              Please complete your registration to join The Networking Salon as
              a Lifetime Partner.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-3544">
              Reference ID: <span className="font-medium" data-id="element-3545">{reference}</span>
            </p>
          </div>
          <div className="max-w-2xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3546">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3547">
              Complete Your Registration
            </h2>
            <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-3548">
              <input type="hidden" name="payment_reference" value={reference} data-id="element-3549" />
              <div data-id="element-3550">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3551">
                  Full Name <span className="text-gray-500" data-id="element-3552">(required)</span>
                </label>
                <input type="text" name="name" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3553" />
              </div>
              <div data-id="element-3554">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3555">
                  Email <span className="text-gray-500" data-id="element-3556">(required)</span>
                </label>
                <input type="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3557" />
              </div>
              <div data-id="element-3558">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3559">
                  Phone Number <span className="text-gray-500" data-id="element-3560">(required)</span>
                </label>
                <input type="tel" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3561" />
              </div>
              <div data-id="element-3562">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3563">
                  Business/Organization{' '}
                  <span className="text-gray-500" data-id="element-3564">(if applicable)</span>
                </label>
                <input type="text" name="business" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3565" />
              </div>
              <div data-id="element-3566">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3567">
                  What are your main goals for joining as a Lifetime Partner?{' '}
                  <span className="text-gray-500" data-id="element-3568">(required)</span>
                </label>
                <textarea name="goals" required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3569" />
              </div>
              <div data-id="element-3570">
                <Button type="submit" className="w-full" data-id="element-3571">
                  Complete Registration
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white" data-id="element-3572">
      <PaystackScript data-id="element-3573" />
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3574">
        <div className="absolute inset-0 z-0" data-id="element-3575">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3576" />
          <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-3577"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3578">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3579">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3580">
              LIFETIME PARTNER ACCESS
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3581">
              Join the Circle of Builders
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3582">
              Strategic partnerships for founders, leaders, and visionaries who
              see relationships as strategy and community as an accelerator for
              growth.
            </p>
            <Button className="text-lg px-8 py-4" onClick={() => {
            setShowPaymentForm(true);
            setTimeout(() => {
              const element = document.getElementById('payment-form');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} data-id="element-3583">
              Get Lifetime Partner Access (₦50,000)
            </Button>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-3584">
        <div className="container mx-auto px-4" data-id="element-3585">
          <div className="max-w-3xl mx-auto" data-id="element-3586">
            <div className="border-2 border-gray-300 rounded-lg p-8 mb-12" data-id="element-3587">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3588">
                🌟 The Networking Salon — Lifetime Partner Access
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3589">
                Welcome to the Circle of Builders.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3590">
                Lifetime Partner Access is designed for those who don't just
                want to network — they want to build. It's for founders,
                leaders, and visionaries who see relationships as strategy and
                community as an accelerator for growth.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3591">
                This tier is for the few who want a deeper seat at the table —
                where ideas become action, projects get personalized support,
                and your brand becomes part of the story we're building
                together.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3592">
                💼 What Lifetime Partner Access Offers
              </h3>
              <div className="space-y-4 mb-8" data-id="element-3593">
                <div className="flex items-start" data-id="element-3594">
                  <span className="mr-2" data-id="element-3595">🎯</span>
                  <div data-id="element-3596">
                    <p className="font-bold text-gray-800" data-id="element-3597">
                      One-on-One Strategic Guidance
                    </p>
                    <p className="text-gray-700" data-id="element-3598">
                      Personalized sessions to refine your goals, business
                      models, or growth strategy — with hands-on guidance
                      tailored to your unique journey.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3599">
                  <span className="mr-2" data-id="element-3600">💡</span>
                  <div data-id="element-3601">
                    <p className="font-bold text-gray-800" data-id="element-3602">
                      Project & Business Handholding
                    </p>
                    <p className="text-gray-700" data-id="element-3603">
                      Get ongoing support on your individual or organizational
                      projects. We help you move from ideas to execution with
                      structure, accountability, and access to tools that work.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3604">
                  <span className="mr-2" data-id="element-3605">🧠</span>
                  <div data-id="element-3606">
                    <p className="font-bold text-gray-800" data-id="element-3607">
                      Access to Advanced Masterminds
                    </p>
                    <p className="text-gray-700" data-id="element-3608">
                      Join curated mastermind circles that bring together
                      high-performing entrepreneurs, creators, and executives
                      focused on intentional growth and collective intelligence.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3609">
                  <span className="mr-2" data-id="element-3610">🌍</span>
                  <div data-id="element-3611">
                    <p className="font-bold text-gray-800" data-id="element-3612">
                      Brand Visibility & Features
                    </p>
                    <p className="text-gray-700" data-id="element-3613">
                      Showcase your brand, initiative, or business across The
                      Networking Salon website and platforms. Your work deserves
                      to be seen — by the right people.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3614">
                  <span className="mr-2" data-id="element-3615">🎟️</span>
                  <div data-id="element-3616">
                    <p className="font-bold text-gray-800" data-id="element-3617">
                      Exclusive Event Benefits
                    </p>
                    <p className="text-gray-700" data-id="element-3618">
                      Enjoy lifetime discounts on all in-person events and
                      experiences hosted by The Networking Salon — from private
                      dinners to public summits.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3619">
                  <span className="mr-2" data-id="element-3620">🗂️</span>
                  <div data-id="element-3621">
                    <p className="font-bold text-gray-800" data-id="element-3622">
                      Resource Catalogue Access
                    </p>
                    <p className="text-gray-700" data-id="element-3623">
                      Gain full access to our growing library of templates,
                      strategy tools, and playbooks that simplify
                      decision-making and amplify your impact.
                    </p>
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3624">
                💎 Your Investment
              </h3>
              <div className="bg-gray-100 p-6 rounded-lg mb-8 text-center" data-id="element-3625">
                <p className="text-2xl font-bold text-gray-800 mb-2" data-id="element-3626">
                  ₦100,000 — Lifetime Access
                </p>
                <p className="text-gray-700 italic" data-id="element-3627">
                  (Currently discounted to ₦50,000)
                </p>
                <p className="text-gray-700 mt-4" data-id="element-3628">
                  This is a one-time investment for those ready to grow
                  intentionally, connect deeply, and align with a network built
                  for impact.
                </p>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3629">
                🌿 Why Become a Lifetime Partner
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3630">
                Becoming a Lifetime Partner means joining a circle of committed
                individuals shaping what The Networking Salon stands for —
                collaboration, generosity, and transformation.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-3631">
                You're not just gaining access — you're becoming a foundational
                voice in a movement that bridges people, purpose, and
                possibility.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-3632">
                This is more than membership. It's partnership — for life. Your
                seat at the table is ready.
              </p>
            </div>
            {showPaymentForm && <div id="payment-form" className="border-2 border-gray-300 rounded-lg p-8" data-id="element-3633">
                <LifetimePartnerForm onSuccess={handleSuccess} data-id="element-3634" />
              </div>}
          </div>
        </div>
      </section>
    </div>;
};